// extracted by mini-css-extract-plugin
export default {"wrapper":"Jm-z","response":"Km-z","error":"Lm-z","disabled":"Mm-z","buttons":"Nm-z","feedbackQuestionSection":"Om-z","yesNoWrapper":"Pm-z"};